var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.shopSeq)?[_c('router-view'),_c('confirm-modal'),_c('alert-modal')]:_vm._e(),_c('spinner')],2)}
var staticRenderFns = []

export { render, staticRenderFns }